import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import {
  Accordion,
  Button,
  Card,
  Modal,
  ModalCloseButton,
  ModalTitle,
  Section,
  SectionText,
} from '..';
import * as Styled from './styled';
import type { BuyerChecklistModalProps } from './types';

export * from './types';

export const BuyerChecklistModal: FC<BuyerChecklistModalProps> = (props) => {
  const { modal, items } = props;
  const { translate } = useTranslation();

  return (
    <Modal {...modal}>
      <Card size="medium" isModal>
        <ModalCloseButton modal={modal} />
        <ModalTitle>{translate('common.modals.buyerChecklist.title')}</ModalTitle>

        <Section centerChildren>
          <SectionText>{translate('common.modals.buyerChecklist.intro')}</SectionText>

          <Accordion
            tabs={items.map((item) => ({
              title: item.title,
              content: (
                <Styled.AccordionContent dangerouslySetInnerHTML={{ __html: item.content }} />
              ),
            }))}
          />

          <Button color="blue" shrink onClick={modal?.onCloseClick}>
            {translate('common.buttons.iUnderstand')}
          </Button>
        </Section>
      </Card>
    </Modal>
  );
};
